import { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, Table, Badge, Form, InputGroup, Button, Modal } from 'react-bootstrap';
import { FaSearch, FaEye, FaBan, FaCheckCircle, FaTimesCircle, FaClock } from 'react-icons/fa';
import '../../../assets/css/Admin/AllDrivers/AllDriver.css';
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const AllDriver = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [drivers, setDrivers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const filteredDrivers = drivers.filter(driver =>
    driver.drivername?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    driver.driverEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    driver.driverphone?.includes(searchTerm)
  );

  const getStatusBadge = (status) => {
    switch(status) {
      case 'Active': return 'success';
      case 'Inactive': return 'warning';
      case 'Pending': return 'info';
      case 'Blocked': return 'danger';
      default: return 'secondary';
    }
  };

  const handleViewDriver = (driver) => {
    setSelectedDriver(driver);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDriver(null);
  };

  useEffect(() => {
    axios.post(`${baseUrl}/admin/users/viewAllDrivers`, {}, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setDrivers(response.data.drivers);
      }
    }).catch((error) => console.log(error));
  }, []);

  return (
    <AdminMasterLayout screenName="drivers">
      <div className="all-driver-container">

        <div className="all-driver-header">
          <div className="all-driver-header-content">
            <h1 className="all-driver-page-title">All Drivers</h1>
            <p className="all-driver-page-subtitle">Manage and view all registered drivers</p>
          </div>
          <div className="all-driver-stats-summary">
            <div className="all-driver-stat-item">
              <span className="all-driver-stat-label">Total Drivers</span>
              <span className="all-driver-stat-value">{drivers.length}</span>
            </div>
            <div className="all-driver-stat-item">
              <span className="all-driver-stat-label">Verified</span>
              <span className="all-driver-stat-value all-driver-stat-verified">
                {drivers.filter(d => d.is_verified == 1).length}
              </span>
            </div>
            <div className="all-driver-stat-item">
              <span className="all-driver-stat-label">Active</span>
              <span className="all-driver-stat-value all-driver-stat-active">
                {drivers.filter(d => d.status === 'Active').length}
              </span>
            </div>
          </div>
        </div>

        <Row className="mb-3">
          <Col lg={12}>
            <Card className="all-driver-search-card">
              <Card.Body className="all-driver-search-body">
                <InputGroup className="all-driver-search-group">
                  <InputGroup.Text className="all-driver-search-icon">
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search by name, email or phone..."
                    className="all-driver-search-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </InputGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="all-driver-table-row">
          <Col lg={12}>
            <Card className="all-driver-table-card">
              <Card.Body className="all-driver-table-body">
                <div className="all-driver-table-wrapper">
                  <Table className="all-driver-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>DRIVER NAME</th>
                        <th>EMAIL</th>
                        <th>PHONE</th>
                        <th>COINS</th>
                        <th>BALANCE</th>
                        <th>VERIFICATION</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDrivers.length > 0 ? (
                        filteredDrivers.map((driver, index) => (
                          <tr key={driver.id}>
                            <td>{index + 1}</td>
                            <td>
                              <div className="all-driver-info">
                                <div className="all-driver-avatar">
                                  {driver.driver_image
                                    ? <img src={driver.driver_image} alt="driver" width={32} height={32} style={{borderRadius:'50%'}} />
                                    : driver.drivername?.charAt(0).toUpperCase()
                                  }
                                </div>
                                <span className="all-driver-name">{driver.drivername}</span>
                              </div>
                            </td>
                            <td className="all-driver-email">{driver.driverEmail}</td>
                            <td>{driver.driverphone}</td>
                            <td>{driver.totalcoins ?? 0}</td>
                            <td>{driver.driverbalance ?? 0}</td>
                            <td>
                              <Badge
                                bg={driver.is_verified == 1 ? 'success' : 'warning'}
                                className="all-driver-verification-badge"
                              >
                                {driver.is_verified == 1
                                  ? <><FaCheckCircle className="all-driver-badge-icon" /> Verified</>
                                  : <><FaClock className="all-driver-badge-icon" /> Pending</>
                                }
                              </Badge>
                            </td>
                            <td>
                              <Badge bg={getStatusBadge(driver.status)} className="all-driver-status-badge">
                                {driver.status === 'Active' && <FaCheckCircle className="all-driver-badge-icon" />}
                                {driver.status === 'Inactive' && <FaTimesCircle className="all-driver-badge-icon" />}
                                {driver.status === 'Pending' && <FaClock className="all-driver-badge-icon" />}
                                {driver.status === 'Blocked' && <FaBan className="all-driver-badge-icon" />}
                                {' '}{driver.status}
                              </Badge>
                            </td>
                            <td>
                              <div className="all-driver-action-buttons">
                                <Button className="all-driver-view-btn" size="sm" onClick={() => handleViewDriver(driver)}>
                                  <FaEye /> View
                                </Button>
                                {driver.status !== 'Blocked' && (
                                  <Button className="all-driver-block-btn" size="sm" title="Block Driver">
                                    <FaBan /> Block
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="all-driver-no-data">No drivers found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered className="all-driver-modal">
          <Modal.Header closeButton className="all-driver-modal-header-custom">
            <Modal.Title className="all-driver-modal-title-custom">
              <FaEye className="me-2" /> Driver Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="all-driver-modal-body-custom">
            {selectedDriver && (
              <div className="all-driver-modal-content-custom">
                <div className="all-driver-modal-top-section">
                  <div className="all-driver-modal-avatar-section">
                    <div className="all-driver-modal-avatar-large-custom">
                      {selectedDriver.driver_image
                        ? <img src={selectedDriver.driver_image} alt="driver" width={64} height={64} style={{borderRadius:'50%'}} />
                        : selectedDriver.drivername?.charAt(0).toUpperCase()
                      }
                    </div>
                  </div>
                  <div className="all-driver-modal-name-section">
                    <h3 className="all-driver-modal-name-custom">{selectedDriver.drivername}</h3>
                    <p className="all-driver-modal-email-custom">{selectedDriver.driverEmail}</p>
                    <div className="all-driver-modal-badges-section">
                      <Badge bg={selectedDriver.is_verified == 1 ? 'success' : 'warning'} className="all-driver-modal-badge-custom">
                        {selectedDriver.is_verified == 1 ? <><FaCheckCircle /> Verified</> : <><FaClock /> Pending</>}
                      </Badge>
                      <Badge bg={getStatusBadge(selectedDriver.status)} className="all-driver-modal-badge-custom">
                        {selectedDriver.status === 'Active' && <FaCheckCircle />}
                        {selectedDriver.status === 'Inactive' && <FaTimesCircle />}
                        {selectedDriver.status === 'Pending' && <FaClock />}
                        {selectedDriver.status === 'Blocked' && <FaBan />}
                        {' '}{selectedDriver.status}
                      </Badge>
                    </div>
                  </div>
                </div>

                <div className="all-driver-modal-info-section">
                  <Row>
                    <Col md={6}>
                      <div className="all-driver-modal-field">
                        <label className="all-driver-modal-field-label">PHONE NUMBER</label>
                        <div className="all-driver-modal-field-value">{selectedDriver.driverphone}</div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="all-driver-modal-field">
                        <label className="all-driver-modal-field-label">TOTAL COINS</label>
                        <div className="all-driver-modal-field-value">{selectedDriver.totalcoins ?? 0}</div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="all-driver-modal-field">
                        <label className="all-driver-modal-field-label">BALANCE</label>
                        <div className="all-driver-modal-field-value">{selectedDriver.driverbalance ?? 0}</div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="all-driver-modal-field">
                        <label className="all-driver-modal-field-label">REGISTERED DATE</label>
                        <div className="all-driver-modal-field-value">
                          {new Date(selectedDriver.created_at).toLocaleDateString()}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

      </div>
    </AdminMasterLayout>
  );
};

export default AllDriver;